module.exports = __webpack_public_path__ + "images/company_profile/icon07-799da2fd07556c15c11e56add8e78f77.png";